import { isArray } from "lodash";
import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import { GlobalFunctionStore } from "imagica-corekit/dist/base/store/GlobalFunctionStore";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { getIt } from "@uikit/getIt";

/**
 * 有关 `useObjectRelationGqlRequest` gql 接口方法(与逻辑无关)
 *
 * @returns
 */
export default function useFuncationsPagination() {
  const { gql } = useObjectRelationGqlRequest();

  /**
   * 获取首页 functions 渲染项目
   *
   * 函数由三个部分组成, 默认，全局，用户三种函数，其中全局和用户函数通过接口查询得到，且加上分页
   *
   * 分页时注意点:
   * 1. 相同页数两个接口一起请求
   * 2. 通过判断两个接口数据是否都为空，得到是否有下一页
   * 3. 传入的 size 拆分
   * 4. 其中一个接口出错，并不能保证另一个接口也出错, 不分页时兼容以前逻辑
   *
   * @param {{page:number, size: number} | undefined} args
   */
  const fetchMyFunctions = async pagination => {
    let userFunctions = [];
    let globalFunctions = [];

    const fetchStudioFunction = gql.query
      .relationSet({ name: "studio_function" }, pagination)
      .then(res => {
        isArray(res) && (userFunctions = res);
      })
      .catch(e => {
        if (pagination) {
          return;
        }
        // 兼容之前逻辑抛出错误
        return Promise.reject(e);
      });

    const fetchStudioFunctionOnly = gql.query
      .objects({
        name: "studio_function",
        globalOnly: true,
        // objects 分页
        ...pagination,
      })
      .then(res => {
        isArray(res) && (globalFunctions = res);
      })
      .catch(e => {
        if (pagination) {
          return;
        }
        // 兼容之前逻辑抛出错误
        return Promise.reject(e);
      });

    await Promise.all([fetchStudioFunction, fetchStudioFunctionOnly]);

    /// 存储数据到corekit
    const globalFunctionStore = getIt(GlobalFunctionStore);
    globalFunctionStore.receive(globalFunctions);
    const personalFunctionStore = getIt(PersonalFunctionStore);
    personalFunctionStore.receive(userFunctions);

    return globalFunctions.concat(userFunctions);
  };

  return {
    gql,
    fetchMyFunctions,
  };
}
